import { createContext } from "react";
import {
  AdState,
  IncrementAdSlot
} from "rivals/components/shared/Ads/provider";

export const AdContext = createContext<AdState>({
  ldrbSlot: 0,
  locationOffset: 0,
  lrecSlot: 0
});
export const AdDispatchContext = createContext<React.Dispatch<IncrementAdSlot>>(
  () => {}
);
